import SolutionCard from "../../reusables/SolutionCard";
import dig from "../../../assets/images/solutions-icon/digital_marketing.svg";

const DigitalMarketingSolution = () => {
  return (
    <SolutionCard
      icon={dig}
      title="Digital Marketing & SEO"
      subtitle="Attract the right audience, convert visitors into customers and grow your brand online"
      ctaLink="/solutions/digital-marketing-seo"
    />
  );
};

export default DigitalMarketingSolution;
